// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__7dM0D","star":"mimic___styles_star__BsSNo","yellow":"mimic___styles_yellow__hx2GK","gray":"mimic___styles_gray__Zgvf3"};